import {Tabs as FDLOLClassicTabs} from 'components/organisms/mode-tabs/components/desktop/fanduel/lol/classic';
import {Tabs as ClassicTabs} from 'components/organisms/mode-tabs/components/desktop/game-types/classic';
import {Tabs as SingleGameTabs} from 'components/organisms/mode-tabs/components/desktop/game-types/single-game';
import {Tabs as ShowDownTabs} from 'components/organisms/mode-tabs/components/desktop/game-types/showdown';
import {Tabs as TiersTabs} from 'components/organisms/mode-tabs/components/desktop/game-types/tiers';
import {Tabs as YahooNflSingleGameTabs} from 'components/organisms/mode-tabs/components/desktop/yahoo/nfl/single-game';

const Factory = {
    getComponent(sportConfig) {
        if (sportConfig.isSiteFanduel()) {
            if (sportConfig.isSportMlb() && sportConfig.isGameTypeSingleGame()) {
                return SingleGameTabs;
            } else if (sportConfig.isSportNba() && sportConfig.isGameTypeSingleGame()) {
                return SingleGameTabs;
            } else if (sportConfig.isSportMma()) {
                return SingleGameTabs;
            } else if (sportConfig.isSportNhl() && sportConfig.isGameTypeSingleGame()) {
                return SingleGameTabs;
            }
        }

        if (sportConfig.isSiteYahoo() && sportConfig.isSportNfl() && sportConfig.isGameTypeSingleGame()) {
            return YahooNflSingleGameTabs;
        }

        if (sportConfig.isSportLol()) {
            if (sportConfig.isSiteFanduel()) {
                return FDLOLClassicTabs;
            }
            return ShowDownTabs;
        }

        if (sportConfig.isSportGolf() && sportConfig.isGameTypeShowDown()) {
            return ClassicTabs;
        }

        if (sportConfig.isSportF1()) {
            return ShowDownTabs;
        }

        if (sportConfig.isGameTypeClassic()) {
            return ClassicTabs;
        }

        if (sportConfig.isGameTypeSingleGame()) {
            return SingleGameTabs;
        }

        if (sportConfig.isGameTypeShowDown()) {
            return ShowDownTabs;
        }

        if (sportConfig.isGameTypeTiers()) {
            return TiersTabs;
        }

        return null;
    },
};

export {Factory};
